// Lightweight, unsafe JWT decode for client-side claim inspection only.
// We never trust these claims for authorization — they are display hints.

export interface AccessClaims {
  sub: string;
  email?: string;
  tenant_id?: string | null;
  super_admin?: boolean;
  impersonation_session_id?: string | null;
  impersonator_email?: string | null;
  exp?: number;
  iat?: number;
}

export function decodeJwt(token: string | null): AccessClaims | null {
  if (!token) return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = payload + "=".repeat((4 - (payload.length % 4)) % 4);
    const json = atob(padded);
    return JSON.parse(json) as AccessClaims;
  } catch {
    return null;
  }
}
